import { useCallback, useEffect, useState } from 'react';
import Button from '../../common/Button/Button';
import Text from '../../common/Text/Text';
import './BookingConfirmation.scss';
import Car from '../../assets/ car.png';
import { useLocation, useNavigate } from 'react-router';
import { formatPrice, MODAL_EXPIRY } from '../../utils/general/general';

const BookingConfirmation = () => {
  const [time, setTime] = useState<number>(MODAL_EXPIRY);
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { state } = useLocation();

  useEffect(() => {
    const int = setInterval(() => {
      setTime(t => t - 1);
    }, 1000);

    return () => {
      clearInterval(int);
    };
  }, []);

  const returnHome = useCallback(() => {
    navigate('/') as void;
  }, [navigate]);

  useEffect(() => {
    if (time === 0) {
      returnHome();
    }
  }, [time, returnHome]);

  return (
    <div className="booking-confirmation">
      <img src={Car} alt="car" className="car" />
      <Text type="header" className="cost-head">
        Estimated Cost
      </Text>
      <Text type="subheader" className="price">
        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
        {state?.price ? formatPrice(Number(state?.price)) : 'Unknown Price'}
      </Text>
      <div className="instructions">
        <Text type="header">
          Please complete your booking using the link we just sent you by text
        </Text>
      </div>
      <Button
        buttonStyleType="secondary"
        label="Resend text message"
        customStyling={{ width: '100%', marginBottom: '8px' }}
      />
      <Button
        buttonStyleType="primary"
        label="Done"
        handleClick={returnHome}
        customStyling={{ width: '100%', marginBottom: '16px' }}
      />
      <Text type="body" size="small">
        Session will end in {String(time)} seconds
      </Text>
    </div>
  );
};

export default BookingConfirmation;
